import axios from "axios";
import { Toast } from "../../util/Toast";

import { SET_ADMIN, SIGNUP_ADMIN, UNSET_ADMIN, UPDATE_PROFILE } from "./types";
import { getAdminAccessByAdminId } from "../adminAccess/action";
import { authApi } from "../../util/adminAuthApi";

// Called after /admin/auth/mfa succeeds: stores the session and loads the
// admin's permissions. Sign-in itself happens in pages/LoginPage.js.
export const startSession = (token, admin) => (dispatch) => {
  dispatch({ type: SET_ADMIN, payload: { token, admin } });
  if (admin?._id) dispatch(getAdminAccessByAdminId(admin._id));
};


// Ends the session on the server first, then clears it locally either way.
export const logoutAdmin = () => async (dispatch) => {
  await authApi.logout().catch(() => {});
  dispatch({ type: UNSET_ADMIN });
  window.location.href = "/";
};

export const signupAdmin = (signup) => (dispatch) => {
  console.log("/admin/signup", signup);
  axios
    .post("/admin/signup", signup)
    .then((res) => {
      console.log(res);
      if (res.data.status) {
        dispatch({ type: SIGNUP_ADMIN });
        Toast("success", "Signup Successfully!");
        setTimeout(() => {
          window.location.href = "/login";
        }, 3000);
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => {
      Toast("error", error);
      console.log(error);
    });
};

export const getProfile = () => (dispatch) => {
  axios
    .get("admin/profile")
    .then((res) => {

      if (res.data.status) {
        dispatch({ type: UPDATE_PROFILE, payload: res.data.admin });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log("error", error.message);
      Toast("error", error.message || "Something went wrong");
    });
};

export const updateNameEmail = (data) => (dispatch) => {
  axios
    .patch("admin", data)
    .then((res) => {
      if (res.data.status) {
        Toast("success", "Profile updated successfully.");
        dispatch({ type: UPDATE_PROFILE, payload: res.data.admin });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};



export const updateCode = (signup) => (dispatch) => {
  console.log("updateCode", signup);
  axios
    .patch("admin/updateCode", signup)
    .then((res) => {
      console.log(res);
      if (res.data.status) {
        console.log('res.data', res.data)
        Toast("success", "Purchase Code Update Successfully !");
        setTimeout(() => {
          window.location.href = "/login";
        }, 3000);
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => {
      Toast("error", error);
      console.log(error);
    });
};